import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class TransloadOrders_ds_get_released_transload_receiving_tasksService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { orderId: number }): 
  Promise<{ result: { Id?: number, ActualTargetLocationId?: number, OrderLine?: { LineNumber?: number, GrossWeight?: number, LotId?: number, PackagedAmount?: number, PackagedId?: number, WeightUomId?: number, Material?: { Id?: number, ControllerTypeId?: number, IsFixedWeight?: boolean } }, ShipmentLine?: { ActualPackagedAmount?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_get_released_transload_receiving_tasks/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { orderId: number, $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, ActualTargetLocationId?: number, OrderLine?: { LineNumber?: number, GrossWeight?: number, LotId?: number, PackagedAmount?: number, PackagedId?: number, WeightUomId?: number, Material?: { Id?: number, ControllerTypeId?: number, IsFixedWeight?: boolean } }, ShipmentLine?: { ActualPackagedAmount?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_get_released_transload_receiving_tasks/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { orderId: number, $keys: number[] }): 
  Promise<{ result: { Id?: number, ActualTargetLocationId?: number, OrderLine?: { LineNumber?: number, GrossWeight?: number, LotId?: number, PackagedAmount?: number, PackagedId?: number, WeightUomId?: number, Material?: { Id?: number, ControllerTypeId?: number, IsFixedWeight?: boolean } }, ShipmentLine?: { ActualPackagedAmount?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.orderId)) {
      missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/TransloadOrders/datasources/ds_get_released_transload_receiving_tasks/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      orderId: number    }) {
        if(isNil(inParams.orderId)) {
          return true; 
        }
      return false;
    }
}
